import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Operacao } from "../api/dto/operacao";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OperacaoFinanceiraService {

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'operacoes/';

    buscarPorId(operacaoId?: number): Observable<Operacao> {
        return this.http.get<Operacao>(this.url + operacaoId);
    }

    listarPorEmpresaESituacao(empresaId?: number, situacao?: boolean): Observable<Operacao[]> {
        return this.http.get<Operacao[]>(this.url + 'empresa/' + empresaId + '/situacao/' + situacao);
    }

    salvar(operacao?: Operacao): Observable<Operacao> {
        return this.http.post<Operacao>(this.url, operacao);
    }

    atualizar(operacao?: Operacao, id?: number): Observable<Operacao>{
        return this.http.put<Operacao>(this.url + id, operacao);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}